import React, { Fragment, useState, useEffect } from "react";
import { useUpdateBadge } from "./badgesServices";
import { lensProp, pick, set } from "ramda";
import { useSnackAlert } from "../common/use-snackAlert";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";

import Badge from "./Badge";
import LoadingIndicator from "../components/LoadingIndicator";

const EditBadgeDialog = props => {
  const { initialBadge, open, onClose } = props;
  const { SnackAlert, showAlert } = useSnackAlert();

  const [badge, setBadge] = useState({});
  useEffect(() => {
    setBadge(initialBadge);
  }, [initialBadge]);

  const handleChange = field => event => {
    const value = event.target.value;
    setBadge(set(lensProp(field), value));
  };

  const updateBadge = useUpdateBadge();
  const handleSave = async () => {
    try {
      const body = pick(["fileName", "fileType", "description"], badge);
      await updateBadge.mutateAsync({
        resourceIds: { id: badge.id },
        data: body,
      });
      showAlert("success", ["Badge Updated"]);
      handleClose();
    } catch (err) {
      showAlert("error", [err.message]);
    }
  };

  const handleClose = () => {
    onClose();
    setBadge({});
  };

  return (
    <Fragment>
      <SnackAlert />

      <Dialog open={open}>
        {updateBadge.isLoading && <LoadingIndicator transparent />}

        <DialogTitle>Edit Badge</DialogTitle>

        <DialogContent>
          <Grid container direction="column" spacing={4}>
            <Grid item container alignItems="flex-end" spacing={2}>
              <Grid item style={{ lineHeight: 0 }}>
                <Badge badge={badge} />
              </Grid>

              <Grid item xs>
                <TextField
                  fullWidth
                  disabled
                  id={`badge-file-name-${badge.id}`}
                  label="File Name"
                  value={badge.fileName || ""}
                />
              </Grid>
            </Grid>

            <Grid item>
              <FormControl fullWidth>
                <InputLabel htmlFor={`badge-type-${badge.id}`}>
                  Badge Type
                </InputLabel>
                <Select
                  inputProps={{
                    name: "badge-type",
                    id: `badge-type-${badge.id}`,
                  }}
                  value={badge.fileType || ""}
                  onChange={handleChange("fileType")}
                  MenuProps={{
                    transformOrigin: {
                      horizontal: "left",
                      vertical: "top",
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                >
                  <MenuItem value="award">Award</MenuItem>
                  <MenuItem value="black">Black</MenuItem>
                  <MenuItem value="white">White</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <TextField
                fullWidth
                id={`badge-description-${badge.id}`}
                label="Badge Description"
                value={badge.description || ""}
                onChange={handleChange("description")}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default EditBadgeDialog;
